import React from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { Box, Button, Tabs, Tab, Badge } from '@mui/material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import HistoryIcon from '@mui/icons-material/History';
import { useAccounts } from '../Context';
import { submitEmployeeAccount } from '../../../../services/request';
import defaultImage from '../../generics/components/default.png';
import UserData from './tabs/UserData';
import ArticleIcon from '@mui/icons-material/Article';
import { ApplicationHistory } from './tabs/ApplicationHistory';
import toast from 'react-hot-toast';

const validationSchema = Yup.object({
  first_name: Yup.string().required('To pole nie może być puste'),
  last_name: Yup.string().required('To pole nie może być puste'),
  email: Yup.string().email('Proszę podać poprawny adres e-mail')
});

export default function AccountForm({ handleAddNewTab }) {
  const { rowData, rows, setRows } = useAccounts();
  const { loading, mutate } = useMutation(submitEmployeeAccount);
  const [currentTab, setCurrentTab] = React.useState(0);
  const ref = React.useRef(null);
  const [preview, setPreview] = React.useState(_.isNil(rowData.photo) ? defaultImage : rowData.photo);
  const [isDefaultPhoto, setisDefaultPhoto] = React.useState(rowData.is_default_photo);

  console.log('rd', rowData);

  const formik = useFormik({
    initialValues: {
      first_name: !_.isNil(rowData.first_name) ? rowData.first_name : '',
      last_name: !_.isNil(rowData.last_name) ? rowData.last_name : '',
      email: !_.isNil(rowData.email) ? rowData.email : '',
      is_active: !_.isNil(rowData.is_active) ? rowData.is_active : false,
      camps: !_.isNil(rowData.employee?.camps) ? rowData.employee?.camps : [],
      zs_weeks_periods: !_.isNil(rowData.employee?.zs_weeks_periods) ? rowData.employee?.zs_weeks_periods : [],
      send_mails_to_manager_user_email: !_.isNil(rowData.employee?.send_mails_to_manager_user_email) ? rowData.employee?.send_mails_to_manager_user_email : false,
      manager_hide_employees: !_.isNil(rowData.employee?.manager_hide_employees) ? rowData.employee?.manager_hide_employees : false,
      is_photo_deleted: false,
      is_photo_changed: false
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: values => {
      console.log('val', values);
      const formData = new FormData();
      formData.append('data', JSON.stringify(values));
      if (!_.isNil(ref.current) && !_.isNil(ref.current.files[0])) {
        formData.append('img', ref.current.files[0]);
      }
      handleSubmit(rowData.id, formData);
    }
  });

  const handlePhotoChange = deleteImage => {
    if (deleteImage) {
      formik.setFieldValue('is_photo_deleted', true);
      setPreview(defaultImage);
    } else {
      formik.setFieldValue('is_photo_deleted', false);
      setPreview(_.isNil(rowData.photo) ? defaultImage : rowData.photo);
    }

    formik.setFieldValue('is_photo_changed', false);

    if (ref.current !== null) {
      ref.current.value = null;
    }
  };

  const handleChangeImage = e => {
    const image = e.target.files[0];
    if (['image/jpg', 'image/jpeg', 'image/png'].includes(image.type)) {
      const r = new FileReader();
      r.onload = e => {
        formik.setFieldValue('is_photo_changed', true);
        setPreview(e.target.result);
      };
      r.readAsDataURL(image);
    } else {
      handlePhotoChange(false);
    }
  };

  const handleSubmit = async (accountId, values) => {
    const { error, payload } = await mutate(accountId, values);
    if (!error) {
      formik.resetForm({
        values: { ...formik.values, is_photo_deleted: false, is_photo_changed: false }
      });
      setisDefaultPhoto(payload.is_default_photo);
      const cloneRows = _.cloneDeep(rows);
      const idx = cloneRows.findIndex(item => item.id == payload.id);
      cloneRows[idx] = payload;
      setRows(cloneRows);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (_.isArray(payload)) {
        toast.error(payload[0]);
      } else {
        toast.error('Nie udało się zapisać zmian');
      }
    }
  };

  React.useEffect(() => {
    if (formik.values.state != rowData.state) {
      console.log('test55');
      formik.setFieldValue('state', rowData.state);
    }
  }, [rowData]);


  return (
    <form onSubmit={formik.handleSubmit}>
      <Tabs value={currentTab} variant="scrollable" onChange={(e, value) => setCurrentTab(value)}>
        <Tab icon={<AssignmentIndIcon />} label="Dane pracownika"/>
        <Tab icon={<ArticleIcon />} label="Aplikacje"/>
      </Tabs>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Button variant="contained" fullWidth disabled={!formik.dirty || loading} type="submit">{loading ? 'Zapisywanie...' : 'Zapisz zmiany'}</Button>
      </Box>
      <Box sx={{ p: 1, height: '65vh', overflow: 'auto' }}>
        {currentTab === 0
          ? <UserData
            formik={formik}
            preview={preview}
            fileInputRef={ref}
            isDefaultPhoto={isDefaultPhoto}
            handlePhotoChange={handlePhotoChange}
            handleChangeImage={handleChangeImage}
            loading={loading}
          />
          : currentTab === 1
            ? <ApplicationHistory rowData={rowData} handleAddNewTab={handleAddNewTab} />
            : null
        }
      </Box>
    </form>
  );
};
